import * as yup from "yup";
export const InviteUsersSchema = yup.object({
	firstName: yup.string().required("Please enter your First Name"),
	lastName: yup.string().required("Please enter your Last Name"),
	email: yup
		.string()
		.email("Must be a valid email address")
		.required("Please enter your Email")
		.email("Please enter a valid Email"),
});
